import DeviceConfig from '@devices/config';
import PhotoDefault from '../../../../shared/assets/images/png/photoDefault.png';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

interface Props {
  height: number;
  width: number;
  src: string;
}

const HorizontalCardImage = styled.img<Props>`
  border-radius: ${16 * Screen.widthRatio}px;
  cursor: pointer;
  height: ${196 * Screen.widthRatio}px;
  left: ${1 * Screen.widthRatio}px;
  position: relative;
  width: ${348 * Screen.widthRatio}px;
  top: ${1 * Screen.widthRatio}px;
  ${() => {
    return DeviceConfig.capabilities?.image?.disableFitCover
      ? ''
      : 'object-fit:cover';
  }};
`;

HorizontalCardImage.defaultProps = {
  src: PhotoDefault,
};

export default withImage(HorizontalCardImage, true, PhotoDefault);
